const mandatoryFields = ['title'];

export default mandatoryFields;
